// extracted by mini-css-extract-plugin
export default {"root":"card_root__F83Mc","heading":"card_heading__8M6Yk","text":"card_text__ESrsk"};